module.exports = __webpack_public_path__ + "media/app/images/lock-icon-09e5e69aae5101f66f4f038cc9e12eaf.png";